export const ArrowReloadHorizontalIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.375 4.125H7.125C4.34004 4.125 2.25 6.13877 2.25 9"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.625 13.875H10.875C13.66 13.875 15.75 11.8613 15.75 9"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.875 2.25C13.875 2.25 15.75 3.63092 15.75 4.12502C15.75 4.61912 13.875 6 13.875 6"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.12498 12C4.12498 12 2.25001 13.3809 2.25 13.875C2.24999 14.3691 4.125 15.75 4.125 15.75"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
